import common from "@/public/common";
import { ajaxApi, ajaxApiNew, getMethod, newAjaxApi } from "@/server/index";
import { getParmUrl, tokenConfig } from "@/public/utils";
import myAxios from "@/server/http";
import { getCookie } from "@/public/utils";

const escmApiHost = common.sqmUrl;
const scpApiHost = common.scpUrl;
const operatorData = {
  operator_id: getCookie("accountId") || "10", //
  operator_name: getCookie("supplier_company_name") || "SCS系统", //supplier_company_name
  role_id_list: [0],
};
// ==================== 字典相关接口 ====================
export const selectOptions = async (code) => {
  return await newAjaxApi({
    url: scpApiHost + 'base/query-dictionary',
    params: {
      'codes': code
    }
  })
}

export const getSomeDictionarys = async () => {
  return await getMethod(scpApiHost + 'supplier-enter/supplier/collection/conditions')
}

export const getSomeDictionarysBy = async () => {
  return await getMethod(scpApiHost + 'supplier-enter/supplier/dict/link?dictGroup=erp_account_period_group')
}

export function getAddressUrl(id, type) {
  var url = {
    'province': 'application/queryAreas?otherdistrict=true',
    'city': 'application/queryAreas?otherdistrict=true' + '&&parentid=' + (id || '') + '&&rank=province',
    'area': 'application/queryAreas?otherdistrict=true' + '&&parentid=' + (id || '') + '&&rank=city',
  }
  return scpApiHost + url[type]
}

// ==================== 银行相关接口 ====================

export const getBankListApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/account/query-bank-list",
    params,
  });
};

export const getFinaceAreaApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/account/query-areas",
    params,
  });
};

export const getBankNumberApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/account/query-bank-number",
    params,
  });
};

// ==================== 企业信息接口 ====================

export const getRequiredFieldsApi = async () => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/query-fields-required",
    params: {},
  });
};

export const saveBaseInfoApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/base-info/save-base-info",
    params,
  });
};

export const queryBaseInfoApi = async () => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/base-info/query-base-info",
    params: { sid: Number(getParmUrl("sid")) },
  });
};

// ==================== 品牌相关接口 ====================

export const getBrandDataApi = async () => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/base-info/query-brand-qua",
    params: { sid: getParmUrl("sid") },
  });
};

export const getAllBrandsApi = async () => {
  return await ajaxApi({
    url: scpApiHost + "application/brand/queryAllBrands",
    params: {},
  });
};

export const syncImgUpload = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  try {
    const res = await myAxios({
      method: "post",
      url: scpApiHost + "supplier-enter/upload-file",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        ...tokenConfig,
      },
    });
    return res;
  } catch (err) {
    return null;
  }
};

export const saveBrandInfoApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "/supplier-enter/base-info/save-brand-qua",
    params,
  });
};

// ==================== 状态查询接口 ====================

export const queryAuditInfoApi = async () => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/query-submit-info",
    params: { sid: getParmUrl("sid") },
  });
};

// ==================== 基础资质接口 ====================

export const queryBaseQuaApi = async () => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/base-info/query-base-qua",
    params: { sid: getParmUrl("sid") },
  });
};

export const saveBaseApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/base-info/base-qua/save-or-submit",
    params,
  });
};

export const queryIsNeedQuaAuditApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "supplier-enter/query-if-need-qua-check",
    params: { sid: getParmUrl("sid") },
  });
};

export const queryIsRepeatApi = async (params) => {
  return await newAjaxApi({
    url: scpApiHost + "/application/query/supplier/exist",
    params: params,
  });
};

// ==================== 资质详情接口（ESCM服务） ====================

export const queryQualificationDetailApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + "supplier/qua/query",
    params: { ...params, ...operatorData },
  });
};

export const saveQualificationDetailApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + "supplier/qua/save",
    params: { ...params, ...operatorData },
  });
};
// ==================== 新接口（ESCM服务） ====================

export const saveSupplierBaseInfoApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/base-info/save',
    params: { ...params, ...operatorData },
  })
}

export const querySupplierBaseInfoApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/base-info/get',
    params: { ...params, ...operatorData },
  })
}
export const baseInfoScsStatusQuery = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/base-info/scs-status/query',
    params: { ...params, ...operatorData },
  })
}

// ==================== 品牌资质授权接口（ESCM服务） ====================

export const queryBrandQuaAuthApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand/qua-auth/query',
    params: { ...params, ...operatorData },
  });
};

export const saveBrandQuaAuthApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand/qua-auth/save',
    params: { ...params, ...operatorData },
  });
};

// ==================== 采购负责人接口 ====================

export const queryPurchaseManagersApi = async (params) => {
  return await ajaxApi({
    url:`${scpApiHost}supplier-enter/query-purchase-managers-new`,
    params: params || {},
  });
};
//供应商-品牌-列表查询
export const supplierBrandQuery = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand/query',
    params: { ...params, ...operatorData },
  });
};
//供应商-品牌-删除
export const supplierBrandDelete = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand/delete',
    params: { ...params, ...operatorData },
  });
};
//品牌信息-列表查询（用于下拉选择）
export const supplierBrandBaseQueryListApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand-base/query-list',
    params: { ...params, ...operatorData },
  });
};
//品牌信息-新增
export const supplierBrandBaseAddApi = async (params) => {
  return await ajaxApiNew({
    url: escmApiHost + 'supplier/brand-base/add',
    params: { ...params, ...operatorData },
  });
};


// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/service.js